module.exports = __webpack_public_path__ + "static/media/vj-videojet-connect.f1886dd2.jpeg";